module.exports = __webpack_public_path__ + "img/logo.53501c0b.png";